import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { UpsellOption, getCheckoutUrl } from '../data/copy';
export function Guarantee({
  selectedUpsell
}: {
  selectedUpsell: UpsellOption;
}) {
  return <section id="garantia" className="relative w-full scroll-mt-16 border-t-2 border-bone/10 bg-steel py-12 sm:py-24" aria-labelledby="garantia-title" data-id="element-51" data-mp="222n2paxov5ul">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-8" data-id="element-52" data-mp="19fsh2ap4y0fj">
        <ShieldCheckIcon className="mx-auto h-10 w-10 text-chartreuse sm:h-12 sm:w-12" aria-hidden="true" data-id="element-53" data-mp="14fxtoh4kjsz8" />
        <p className="mt-4 font-cond text-xs uppercase tracking-[0.28em] text-chartreuse sm:mt-5 sm:text-sm" data-id="element-54" data-mp="1j5c29n0bm6dk">
          Garantía de hierro
        </p>
        <h2 id="garantia-title" className="mt-3 font-display text-2xl uppercase leading-[0.95] text-bone sm:mt-4 sm:text-5xl" data-id="element-55" data-mp="qo9hkdubl4i9">
          Dos salidas al agua.
          <span className="block text-chartreuse" data-id="element-56" data-mp="lnbzs2d82cha">Si no sientes el ataque, te devolvemos todo.</span>
        </h2>
        <p className="mt-4 font-body text-[0.95rem] leading-relaxed text-bone/80 sm:mt-6 sm:text-lg" data-id="element-57" data-mp="tymf0008r8v0">
          Amarra el Pitbull, tírale con el Senko, arrastra el Cangrejo. Dale dos
          jornadas completas. Si el instinto del pez no responde, si sientes que
          la textura o la vibración no están a la altura de lo que acabas de
          leer, escríbenos por WhatsApp con una foto de tu pack.
        </p>
        <p className="mt-4 font-cond text-lg uppercase leading-snug tracking-wide text-bone sm:mt-5 sm:text-xl" data-id="element-58" data-mp="az8mznm2o875">
          Te regresamos tus ${selectedUpsell.price} completos y los señuelos usados te los quedas.
          Sin formularios, sin devoluciones, sin cara larga. El riesgo lo
          cargamos nosotros — a ti te toca clavar.
        </p>
        <CtaButton size="md" source="garantia" href="#pack" itemName={selectedUpsell.title} value={selectedUpsell.price} className="mt-7 w-full sm:hidden" data-id="element-59" data-mp="1qg8x8duq9gcz">
          ¡Quiero pescar más ya! → ${selectedUpsell.price}
        </CtaButton>
        <CtaButton source="garantia" href="#pack" itemName={selectedUpsell.title} value={selectedUpsell.price} className="mt-10 hidden sm:inline-flex" data-id="element-60" data-mp="3nheu2vzznosh">
          ¡Quiero pescar más ya! → ${selectedUpsell.price}
        </CtaButton>
      </div>
    </section>;
}